export default __webpack_public_path__ + "static/meet-the-team-slide-2-3bc694db23d20ebcd9d9993a68298387.jpg";